import { init, captureMessage } from '@sentry/browser';

const initializeSentry = () => {
    if (window.location.host === __FRONTEND_URL__) {
        init({
            dsn: __SENTRY_KEY__,
            environment: __ENVIRONMENT__
        });
    }
};

export default initializeSentry;
